import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

export const Spacer = ({spacer_size}) => {
    const height = spacer_size === 'large' ? '10px' : '5px'

    return <Box height={height} />
}

Spacer.propTypes = {
    spacer_size: PropTypes.string
}

export default Spacer
